/**
 * Hook pour gérer le mode "Reader App" iOS
 * 
 * Apple exige l'In-App Purchase pour les abonnements.
 * Pour éviter les frais Apple, l'app iOS devient une "Reader App" :
 * - Premium iOS : accès complet, mais ne peut pas gérer son abonnement dans l'app
 * - Non-premium iOS : accès minimal, sans aucune référence à premium/prix/abonnement
 */

import { Capacitor } from '@capacitor/core';
import { useAuth } from '../context/AuthContext';

export const useIOSReaderMode = () => {
  const { user } = useAuth();
  
  // Détection de la plateforme iOS native
  const isIOSApp = Capacitor.getPlatform() === 'ios' && Capacitor.isNativePlatform();
  
  // Utilisateur iOS gratuit (non-premium)
  const isIOSFreeUser = isIOSApp && !user?.is_premium;
  
  return { 
    isIOSApp, 
    isIOSFreeUser, 
    isPremium: !!user?.is_premium 
  };
};

export default useIOSReaderMode;

